
import { ERROR_PAGE_NAME } from '../utils/EndPoint'
export default {
  name: ERROR_PAGE_NAME,
  props: {
    message: {
      type: String,
      default: ''
    }, // 에러 Message
    resultCode: {
      type: String,
      default: ''
    },
    showConfirmBtnFlag: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close () {
      const groupUrl = sessionStorage.getItem('groupUrl')
      const url = sessionStorage.getItem('url')
      if (groupUrl) {
        window.location.replace(`${groupUrl}`)
      } else {
        window.location.replace(`${url}`)
      }
    }

  }
}
